export enum TextBlockIntroPosition {
	default = 0,
	belowTitle = 1,
	aboveText = 2,
}
